import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllRoles,
  addNewRole,
  deletRolebyId,
  getRolePermissions,
  updateRolePermissions,
  getallroleclaims,
} from './thunks';
import { RolesState } from './types';

export const name = 'roles';

const initialState: RolesState = {
  data: [],
  details: null,
  rolesClaims: [],
  status: 'idle',
  updateStatus: 'idle',
  claimsStatus: 'idle',
};
export const getAllRolesAsync = createAsyncThunk(
  name + '/getAllRoles',
  getAllRoles
);

export const addNewRoleAsync = createAsyncThunk(
  name + '/addNewRole',
  addNewRole
);

export const deletRolebyIdAsync = createAsyncThunk(
  name + '/deletRolebyId',
  deletRolebyId
);

export const getRolePermissionsAsync = createAsyncThunk(
  name + '/getRolePermissions',
  getRolePermissions
);

export const updateRolePermissionsAsync = createAsyncThunk(
  name + '/updateRolePermissions',
  updateRolePermissions
);

export const getallroleclaimsAsync = createAsyncThunk(
  name + '/getallroleclaims',
  getallroleclaims
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRolesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllRolesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllRolesAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getallroleclaimsAsync.pending, (state) => {
        state.claimsStatus = 'loading';
      })
      .addCase(getallroleclaimsAsync.fulfilled, (state, action) => {
        state.claimsStatus = 'idle';
        state.rolesClaims = action.payload;
      })
      .addCase(getallroleclaimsAsync.rejected, (state) => {
        state.claimsStatus = 'failed';
      })
      .addCase(getRolePermissionsAsync.pending, (state) => {
        state.updateStatus = 'loading';
      })
      .addCase(getRolePermissionsAsync.fulfilled, (state, action) => {
        state.updateStatus = 'idle';
        state.details = action.payload;
      })
      .addCase(getRolePermissionsAsync.rejected, (state) => {
        state.updateStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
